import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'error-dialog',
  templateUrl: './error-dialog.component.html',
})
export class ErrorDialogComponent {
  public title: string;
  public message: string;

  constructor(public dialogRef: MatDialogRef<ErrorDialogComponent>) {}

  close() {
    console.log(this.dialogRef);
    this.dialogRef.close(null);
  }
}
